import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { LogIn, Lock, User } from 'lucide-react';
import { toast } from '../../hooks/use-toast';

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const result = await login(username, password);
    
    if (result.success) {
      toast({
        title: "Login Successful",
        description: "Welcome to Reagle CMS",
      });
      navigate('/admin/dashboard');
    } else {
      toast({
        title: "Login Failed",
        description: result.message || "Invalid credentials",
        variant: "destructive"
      });
    }
    
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#0A1A50] to-[#060F2E]">
      <div className="bg-white p-8 rounded-lg shadow-2xl w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-[#0A1A50] rounded-full flex items-center justify-center mx-auto mb-4">
            <Lock className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-3xl font-light text-[#2d2d2d] mb-2">Reagle CMS</h1>
          <p className="text-[#2d2d2d] font-light">Admin Panel Login</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-normal text-[#2d2d2d] mb-2">
              Username
            </label>
            <div className="relative">
              <User className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-[#2d2d2d]" />
              <Input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Enter username"
                className="pl-10"
                required
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-normal text-[#2d2d2d] mb-2">
              Password
            </label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-[#2d2d2d]" />
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
                className="pl-10"
                required
              />
            </div>
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="w-full bg-[#0A1A50] hover:bg-[#060F2E] text-white py-6 text-lg rounded-lg shadow-lg hover:shadow-xl transition-all duration-300"
          >
            {loading ? 'Logging in...' : 'Login'}
            <LogIn className="ml-2 w-5 h-5" />
          </Button>
        </form>

        <div className="mt-6 p-4 bg-gray-50 rounded-lg">
          <p className="text-sm text-[#2d2d2d] text-center font-light">
            <strong>Demo Credentials:</strong><br />
            Username: <code className="bg-gray-200 px-2 py-1 rounded">admin</code><br />
            Password: <code className="bg-gray-200 px-2 py-1 rounded">reagle2024</code>
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;